<template>
    <div class="animated">
        <form @submit.prevent="onSubmit" role="form">
            <b-field
                :label="$t('Email')"
                :type="form.errors.has('email') ? 'is-danger' : null"
                :message="form.errors.get('email')"
            >
                <b-input
                    v-model="form.email"
                    type="email"
                    :placeholder="$t('Email')"
                    icon="email-outline"
                    name="email"
                    required
                    readonly
                    size="is-medium"
                />
            </b-field>

            <b-field
                :label="$t('New password')"
                :type="form.errors.has('password') ? 'is-danger' : null"
                :message="form.errors.get('password')"
            >
                <b-input
                    v-model="form.password"
                    type="password"
                    :placeholder="$t('New password')"
                    icon="lock"
                    password-reveal
                    name="password"
                    required
                    autofocus
                    size="is-medium"
                />
            </b-field>

            <b-field
                :label="$t('Password confirmation')"
                :type="form.errors.has('password_confirmation') ? 'is-danger' : null"
                :message="form.errors.get('password_confirmation')"
            >
                <b-input
                    v-model="form.password_confirmation"
                    type="password"
                    :placeholder="$t('Password confirmation')"
                    icon="lock"
                    password-reveal
                    name="password_confirmation"
                    required
                    size="is-medium"
                />
            </b-field>

            <div class="field">
                <p class="control">
                    <button type="submit" class="button is-primary is-medium is-fullwidth">
                        {{ $t('Reset password') }}
                    </button>
                </p>
            </div>

            <p class="has-text-centered">
                <router-link :to="{ name: 'login' }">
                    {{ $t('Back to login') }}
                </router-link>
            </p>
        </form>
    </div>
</template>

<script>
let fields = {};

export default {
    props: ['token'],

    data() {
        // Init fields
        fields = {
            token: '',
            email: '',
            password: '',
            password_confirmation: ''
        };

        return {
            form: new Form(fields)
        };
    },

    mounted() {
        this.form.token = this.token;
        document.title = i18n.t('Lost password') + ` | ${AppTitle}`;
        this.form.email = getQueryParam('email');
    },

    methods: {
        onSubmit() {
            this.form
                .post('/lost-password/reset')
                .then(response => {
                    window.location = response.data.google2fa ? '/2fa' : '/app';
                })
                .catch(() => {});
        }
    }
};
</script>
